export default "__VITE_ASSET__506dca74__"